import { createContext, useContext, useState } from "react";

interface PendingMessage {
  msg: string;
  options?: Record<string, unknown>;
}

interface PendingMessageContextType {
  pendingMessage?: PendingMessage;
  setPendingMessage: (message: PendingMessage) => void;
  clearPendingMessage: () => void;
}

const PendingMessageContext = createContext<
  PendingMessageContextType | undefined
>(undefined);

export const PendingMessageProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [pendingMessage, setPendingMessageState] = useState<
    PendingMessage | undefined
  >(undefined);

  return (
    <PendingMessageContext.Provider
      value={{
        pendingMessage,
        setPendingMessage: setPendingMessageState,
        clearPendingMessage: () => setPendingMessageState(undefined),
      }}
    >
      {children}
    </PendingMessageContext.Provider>
  );
};

export const usePendingMessage = () => {
  const context = useContext(PendingMessageContext);
  if (!context) {
    throw new Error(
      "usePendingMessage must be used within a PendingMessageProvider"
    );
  }
  return context;
};
